import { theme } from 'antd';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { selectPeople } from 'reduxStore/people/selectors';
import { selectCredentials } from 'reduxStore/credentials/selectors';
import { selectCredentialTypes } from 'reduxStore/types/selectors';
import CredentialDrawer from 'zComponents/molecules/CredentialDrawer';
import { Button, Col, Empty, Flex, Row, Typography } from 'zui/Antd';

const { Text } = Typography;

function RenderCredentialsPanelContent({ searchResults = [], isSearching = false }) {
	const {
		token: {
			colorTextLabel,
			fontWeightStrong,
			padding,
			borderRadius,
			paddingSM,
			colorFill,
			colorPrimaryText,
			lineHeight,
			lineHeightLG,
			fontSizeLG
		}
	} = theme.useToken();
	const CredentialTypes = useSelector(selectCredentialTypes);

	const allPeople = useSelector(selectPeople);
	const allCredentialsData = useSelector(selectCredentials);

	const [openDrawer, setOpenDrawer] = useState(false);
	const [selectedCredential, setSelectedCredential] = useState(null);
	const displayData = isSearching ? searchResults.map((result) => result.item) : allCredentialsData;

	if (displayData.length === 0) {
		return (
			<Flex align='center' justify='center' vertical style={{ width: '100%', padding }}>
				<Empty description={isSearching ? 'No search results found' : 'No credentials to display'} />
			</Flex>
		);
	}

	return (
		<Row gutter={[20, 20]} justify='start'>
			{displayData.map((credential, index) => (
				<Col key={isSearching ? `search-${index}` : index} xl={8} lg={12} sm={24}>
					<Flex
						vertical
						style={{
							border: `1px solid ${colorFill}`,
							padding: paddingSM,
							borderRadius,
							boxSizing: 'border-box'
						}}
					>
						<Flex align='center' justify='space-between'>
							<Flex vertical flex={1} style={{ width: 0 }}>
								<Text
									ellipsis={{ tooltip: credential?.name }}
									style={{
										width: '100%',
										color: colorTextLabel,
										fontWeight: fontWeightStrong,
										fontSize: fontSizeLG,
										lineHeight: lineHeightLG
									}}
								>
									{credential?.name || '--'}
								</Text>
								<Text
									ellipsis={{
										tooltip: `Category: ${CredentialTypes?.find((type) => type.credentialTypeID === credential?.credentialTypeID)?.name || '-'}`
									}}
									style={{
										width: '100%',
										color: colorTextLabel,
										fontWeight: 500,
										lineHeight: lineHeight
									}}
								>
									Category:{' '}
									{CredentialTypes?.find(
										(type) => type.credentialTypeID === credential?.credentialTypeID
									)?.name || '--'}
								</Text>
								<Text
									ellipsis={{
										tooltip: `Assigned Person: ${allPeople?.find((person) => person.personID === credential?.personID)?.displayName || '-'}`
									}}
									style={{
										width: '100%',
										color: colorTextLabel,
										fontWeight: 500,
										lineHeight: lineHeight
									}}
								>
									Assigned Person:{' '}
									{allPeople?.find((person) => person.personID === credential?.personID)
										?.displayName || '--'}
								</Text>
							</Flex>
							<Button
								onClick={() => {
									setSelectedCredential(credential?.credentialID);
									setOpenDrawer(true);
								}}
								type='text'
								style={{ color: colorPrimaryText }}
							>
								View Credentials
							</Button>
						</Flex>
					</Flex>
				</Col>
			))}
			<CredentialDrawer credentialID={selectedCredential} visible={openDrawer} setVisible={setOpenDrawer} />
		</Row>
	);
}

export default RenderCredentialsPanelContent;
